var irreducible = require('./irreducible');
var isArray = require('./isArray');

module.exports = irreducible('Array', isArray);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/Array.js
 ** module id = 1029
 ** module chunks = 0
 **/